import { ActionContext } from "vuex";
import { State } from "../state";
import { AdminState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";

type MainContext = ActionContext<AdminState, State>;

export const actions = {};

const { dispatch } = getStoreAccessors<AdminState, State>("");
